import { useMemo } from 'react';

const useHasError = ( { items = [] } ) => {
    
    const hasError = useMemo( () => {
        return items.find( i => ( i !== undefined && i !== false ) ) || false;
    }, [ items ] );

    return useMemo( () => {
        return {
            hasError,
            errors: items,
            errorString: items.filter( i => !!i ).map( i => i.toString() ).join( '\n' )
        };
    }, [ hasError, items ] );
};

export default useHasError;
